import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Table, Input, Button } from "semantic-ui-react";
import { clone, applySnapshot, getSnapshot } from 'mobx-state-tree';

class AdditionalCostsTableRow extends Component {
  state = {
    isEditing: false,
    clone: null
  }
  render() { 
    if (this.state.isEditing) return this.renderEditableRow()
    const { item } = this.props
    return (
      <Table.Row>
        <Table.Cell>{item.description}</Table.Cell>
        <Table.Cell positive={item.isCostEdited}>${item.cost}</Table.Cell>
        <Table.Cell>
          <a href='#edit-additional-cost-item' onClick={this.editItem}>Edit</a>
        </Table.Cell>
      </Table.Row>
    )
  }
  renderEditableRow = () => (
    <Table.Row>
      <Table.Cell>{this.state.clone.description}</Table.Cell>
      <Table.Cell>
        <Input type='number' step='0.01' value={this.state.clone.cost} onChange={this.onChangeCost} />
      </Table.Cell>
      <Table.Cell>
        <Button type='button' size='small' color='olive' onClick={this.applyChanges}>Done</Button>
        <Button type='button' size='small' color='orange'  onClick={this.cancelEditing}>Cancel</Button>
      </Table.Cell>
    </Table.Row>
  )
  editItem = () => {
    this.setState({
      isEditing: true,
      clone: clone(this.props.item)
    })
  }
  onChangeCost = event => {
    var parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.state.clone.setCost(parsedValue)
  }
  applyChanges = () => {
    applySnapshot(this.props.item, getSnapshot(this.state.clone))
    this.cancelEditing()
  }
  cancelEditing = () => {
    this.setState({
      isEditing: false,
      clone: null
    })
  }
}
 
export default observer(AdditionalCostsTableRow);


// WEBPACK FOOTER //
// ./src/components/jobs/EstimateOtherCostsTableRow.js